import { useEffect } from "react";

let lockCount = 0;
let previousOverflow = "";
let previousPaddingRight = "";

const getScrollbarWidth = (): number => {
    if (typeof window === "undefined" || typeof document === "undefined") {
        return 0;
    }

    return Math.max(window.innerWidth - document.documentElement.clientWidth, 0);
};

const lockBodyScroll = () => {
    if (typeof document === "undefined" || !document.body) {
        return;
    }

    if (lockCount === 0) {
        previousOverflow = document.body.style.overflow;
        previousPaddingRight = document.body.style.paddingRight;
        const scrollbarWidth = getScrollbarWidth();

        document.body.style.overflow = "hidden";
        if (scrollbarWidth > 0) {
            document.body.style.paddingRight = `${scrollbarWidth}px`;
        }
    }

    lockCount += 1;
};

const unlockBodyScroll = () => {
    if (typeof document === "undefined" || !document.body || lockCount === 0) {
        return;
    }

    lockCount -= 1;
    if (lockCount === 0) {
        document.body.style.overflow = previousOverflow;
        document.body.style.paddingRight = previousPaddingRight;
    }
};

export const useBodyScrollLock = (): void => {
    useEffect(() => {
        if (typeof window === "undefined" || typeof document === "undefined") {
            return undefined;
        }

        lockBodyScroll();
        return () => {
            unlockBodyScroll();
        };
    }, []);
};
